import React, { Component } from "react";
import { createPortal } from "react-dom";

const modalStyle = {
    position: "fixed",
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    backgroundColor: "rgba(0,0,0,.2)",
    color: "##FFF",
    fontSize: "40px",
};
export default class Modal extends Component {
    render() {
        return createPortal(
            <div style={modalStyle} onClick={this.props.onClick}>
                {this.props.children}
            </div>,
            document.getElementById("modal_root")
        );
    }
}

/*
  <LinkButton className="btn btn-primary" to={`${props.match.url}/edit`} >Scan</LinkButton>
   <Route
                path={`${props.match.url}/edit`}
                render={() => {
                    return (
                        <MyModal
                            onClick={() => {
                                //this.props.history.push(this.props.match.url);
                                props.history.goBack();
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                }}
                            >

                            </div>
                        </MyModal>
                    );
                }}
            />
 */